import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { COPY_SPEACH } from '@/store/actions/speach';
import { CopySpeachStatus } from '@/store/enums/speachEnum';
import SpeachResultTable from '@/components/platform/copySpeach/SpeachResultTable.vue';
import Banner from '@/components/banner/Banner.vue';
var ResultCopySpeach = /*#__PURE__*/function (_Vue) {
  function ResultCopySpeach() {
    var _this;
    _classCallCheck(this, ResultCopySpeach);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResultCopySpeach, [].concat(args));
    _defineProperty(_this, "loading", true);
    _defineProperty(_this, "speachCopied", 0);
    return _this;
  }
  _inherits(ResultCopySpeach, _Vue);
  return _createClass(ResultCopySpeach, [{
    key: "mounted",
    value: function mounted() {
      this.launchCopy();
    }
  }, {
    key: "launchCopy",
    value: function () {
      var _launchCopy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _iterator, _step, _this$sourcePlatform, _this$destinationPlat, c;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              this.speachCopied = 0;
              _iterator = _createForOfIteratorHelper(this.listSpeachToCopy);
              _context.prev = 3;
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context.next = 12;
                break;
              }
              c = _step.value;
              _context.next = 9;
              return store.dispatch(COPY_SPEACH, {
                platformSourceID: (_this$sourcePlatform = this.sourcePlatform) === null || _this$sourcePlatform === void 0 ? void 0 : _this$sourcePlatform.platformID,
                platformDestinationID: (_this$destinationPlat = this.destinationPlatform) === null || _this$destinationPlat === void 0 ? void 0 : _this$destinationPlat.platformID,
                courToCopy: c
              });
            case 9:
              this.speachCopied++;
            case 10:
              _context.next = 5;
              break;
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              _iterator.e(_context.t0);
            case 17:
              _context.prev = 17;
              _iterator.f();
              return _context.finish(17);
            case 20:
              this.loading = false;
              this.$emit('speachesCopied');
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 14, 17, 20]]);
      }));
      function launchCopy() {
        return _launchCopy.apply(this, arguments);
      }
      return launchCopy;
    }()
  }, {
    key: "listSpeachToCopy",
    get: function get() {
      return store.getters.listSpeachToCopy;
    }
  }, {
    key: "totalSpeachCopiedSuccess",
    get: function get() {
      return this.listSpeachToCopy.filter(function (x) {
        return CopySpeachStatus.SUCCESS === x.copySpeachStatus;
      }).length;
    }
  }, {
    key: "totalSpeachCopiedError",
    get: function get() {
      return this.listSpeachToCopy.filter(function (x) {
        return CopySpeachStatus.ERROR === x.copySpeachStatus;
      }).length;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
  }, {
    key: "destinationPlatform",
    get: function get() {
      return store.getters.destinationPlatform;
    }
  }]);
}(Vue);
ResultCopySpeach = __decorate([Options({
  components: {
    SpeachResultTable: SpeachResultTable,
    Banner: Banner
  }
})], ResultCopySpeach);
export default ResultCopySpeach;